import { addToFavorites } from './addToFavorite';
import { TFavoriteOfferRef } from './types';
import { TThunkAction } from '../../types/redux';
import { requestAuthentication } from '../authentication/requestAuthentication';

export const onAddToFavorite = (offer: TFavoriteOfferRef): TThunkAction<Promise<void>> => {
  return async (dispatch, getState, context) => {
    const { microfrontendsAPI } = context;
    const { user } = getState();

    if (microfrontendsAPI?.header && !user.isAuthenticated) {
      microfrontendsAPI.header.openAuthModal({ autoRefresh: false, viewData: { headingType: 'addFavorite' } });
      dispatch(
        requestAuthentication({
          source: 'favorites',
          viewData: { headingType: 'addFavorite' },
          onSuccess: (): TThunkAction => dispatch => {
            dispatch(addToFavorites(offer));
          },
        }),
      );
    } else {
      dispatch(addToFavorites(offer));
    }
  };
};
